import React from "react";
import { Route, Link } from "react-router-dom";
import baseImage from "../../../../assets/images/content-for-photography.jpg";
import questionIcon from "../../../../assets/images/icons/MA-Question-Icon";


export default class VirtualSuiteTypeItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let virtual_suite_type = this.props.virtual_suite_type;
    let id = "";
    let textId = "";
    let imageId = "";

    if (this.props.selected) {
      id = "virtualStagingCategorySelected"
      textId = "categoryItemTextSelected"
      imageId = "categoryItemImageSelected"
    }


    return (
      <div onClick={() => this.props.toggleSelected(virtual_suite_type)} id={id} className="virtual-staging-modal-category-container virtual-suite-container">
        <img id={imageId} className="categoryItemImage" src={virtual_suite_type.cover}></img>
        <div className="categoryItemDescriptionDiv">
          <div className="categoryItemText" id={textId}>{virtual_suite_type.name}</div>
          <div className="toolTip"><img className="categoryQuestionIcon" src={questionIcon} />
            {virtual_suite_type.description ? <span className="categoryDescription">{virtual_suite_type.description}</span> : ""}
          </div>
        </div>
      </div>
    )
  }
}